"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
require("../../styles/CustomerListPage.css");
require("../../styles/TicketListPage.css");
var AddNewTicketButton_1 = require("./modals/AddNewTicketButton");
var ticket_1 = require("../../api/ticket");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var graph_1 = require("../../graph");
var customer_1 = require("../../api/customer");
var TicketDeleteButton_1 = require("./modals/TicketDeleteButton");
var react_moment_1 = require("react-moment");
var table_1 = require("../table/table");
var pagination_1 = require("../pagination/pagination");
var getStatusColor = function (value) {
    var result = "";
    switch (value.toLowerCase()) {
        case 'unattended':
            result = "./ellipseblue.svg";
            break;
        case 'attended':
            result = "./ellipsegreen.svg";
            break;
        case 'inprogress':
            result = "./ellipseyellow.svg";
            break;
        case 'closed':
            result = "./ellipsered.svg";
            break;
        default:
            result = "./ellipseblue.svg";
    }
    return result;
};
// ticket status option
var ticketStatusOptions = [
    { key: "", value: "All" },
    { key: "0", value: "Unattended" },
    { key: "1", value: "Attended" },
    { key: "2", value: "InProgress" },
    { key: "3", value: "Closed" }
];
var TicketListPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var _a = (0, react_1.useState)({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = (0, react_1.useState)({
        purchasedLicenses: new Array()
    }), company = _b[0], setCompany = _b[1];
    var _c = (0, msal_react_1.useMsal)(), inProgress = _c.inProgress, instance = _c.instance, accounts = _c.accounts;
    var _d = (0, react_1.useState)(false), isAuthorizedSuperAdmin = _d[0], setIsAuthorizedSuperAdmin = _d[1];
    var _e = (0, react_1.useState)(new Array()), list = _e[0], setList = _e[1];
    var _f = (0, react_1.useState)(false), isLoaded = _f[0], setIsLoaded = _f[1];
    var pushToList = function (item) {
        setList(__spreadArray([__assign({}, item)], list, true));
    };
    var _g = (0, react_1.useState)(""), searchTerm = _g[0], setSearchTerm = _g[1];
    var _h = (0, react_1.useState)(""), selectStatus = _h[0], setSelectStatus = _h[1];
    // get selected status to filter 
    var handleSelect = function (e) {
        setSelectStatus(e.target.value);
        console.log(selectStatus);
    };
    var ticketListColumns = [
        {
            Header: 'Ticket No.',
            accessor: 'ticketNum',
            Cell: function (row) { return (React.createElement("div", { className: "" },
                React.createElement("a", { className: "padding-default", href: '/ticket/' + getIdByTicketNum(row.value) }, row.value))); }
        },
        {
            Header: 'Company Name',
            id: 'ticketId',
            accessor: 'ticketId',
            Cell: function (row) {
                return React.createElement("div", { id: "CompanyName" },
                    React.createElement("div", { id: "CreatorProfilePic" },
                        React.createElement("img", { className: "logo-image", src: getProfilePicById(row.value) })),
                    React.createElement("div", { id: "CompName-Text" },
                        React.createElement("td", { id: "CompName-Text" }, getCompanyNameById(row.value))));
            }
        },
        {
            Header: 'Creator Name',
            accessor: 'creatorName',
        },
        {
            Header: 'Title ',
            accessor: 'title'
        },
        //{
        //    Header: 'Description',
        //    accessor: 'description',
        //},
        {
            Header: 'Package',
            accessor: 'package'
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: function (row) { return (React.createElement("div", null,
                React.createElement("img", { src: getStatusColor(row.value), className: "font-icon" }),
                row.value)); }
        },
        {
            Header: 'Tier',
            accessor: 'tier'
        },
        {
            Header: 'Last Updated',
            accessor: 'modifiedAt',
            Cell: function (row) { return (React.createElement(React.Fragment, null,
                React.createElement(react_moment_1.default, { format: "DD MMM YYYY hh:mm A" }, row.value))); }
        },
        {
            Header: 'Action',
            id: 'actionId',
            accessor: 'ticketId',
            Cell: function (row) { return (React.createElement("div", { className: "action-button" },
                React.createElement(TicketDeleteButton_1.default, { id: row.value, modalCallback: updateTicketCallback }))); }
        }
    ];
    var columns = ticketListColumns;
    // server pagination
    var _j = (0, react_1.useState)({
        rowData: [],
        isloading: false,
        //totalPages: 0,
        totalTickets: 0,
    }), pageData = _j[0], setPageData = _j[1];
    var _k = (0, react_1.useState)(1), currentPage = _k[0], setCurrentPage = _k[1];
    // search and status filter (filterclick)
    var filterClick = function () {
        (0, ticket_1.fetchTickets)(currentPage, searchTerm, selectStatus).then(function (info) {
            var list = info.list, count = info.count, page = info.page;
            setPageData({
                isloading: false,
                rowData: list,
                totalTickets: count,
            });
            setIsLoaded(true);
        });
    };
    var getIdByTicketNum = function (num) {
        if (pageData.rowData != null && pageData.rowData.length > 0) {
            return pageData.rowData.reduce(function (acc, item) {
                if (item.ticketNum == num)
                    acc = item.ticketId;
                return acc;
            }, 0);
        }
    };
    var getProfilePicById = function (num) {
        if (pageData.rowData != null && pageData.rowData.length > 0) {
            return pageData.rowData.reduce(function (acc, item) {
                if (item.ticketId == num && item.companyLogo != null)
                    acc = item.companyLogo;
                return acc;
            }, "./images/companyDefault.svg");
        }
    };
    var getCompanyNameById = function (num) {
        if (pageData.rowData != null && pageData.rowData.length > 0) {
            return pageData.rowData.reduce(function (acc, item) {
                if (item.ticketId == num)
                    acc = item.companyName;
                return acc;
            }, "Company Name Unknown");
        }
    };
    var requestProfileData = function () {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent(__assign(__assign({}, authConfig_1.loginRequest), { account: accounts[0] })).then(function (response) {
            (0, graph_1.callMsGraph)("GET", response.accessToken, authConfig_1.graphConfig.graphMeEndpoint).then(function (response) {
                setGraphData(response);
            });
        });
    };
    var checkIfSuperAdmin = function () {
        var currentAccount = instance.getActiveAccount();
        if (currentAccount && currentAccount.idTokenClaims) {
            var tokenClaims = currentAccount.idTokenClaims['roles'];
            console.log('token');
            console.log(tokenClaims);
            var intersection = tokenClaims.includes(authConfig_1.appRoles.SuperAdmin);
            if (intersection) {
                setIsAuthorizedSuperAdmin(true);
            }
        }
    };
    var populateList = function () {
        if (isAuthorizedSuperAdmin) {
            if (!isLoaded) {
                //fetchTickets(currentPage).then((data: any) => {
                //    setList(data.list);
                //    setIsLoaded(true);
                //}).catch(console.error);
                setPageData(function (prevState) { return (__assign(__assign({}, prevState), { rowData: [], isloading: true })); });
                (0, ticket_1.fetchTickets)(currentPage, searchTerm, selectStatus).then(function (info) {
                    var list = info.list, count = info.count, page = info.page;
                    setPageData({
                        isloading: false,
                        rowData: list,
                        //totalPages,
                        totalTickets: count,
                    });
                    //setIsLoaded(true);
                    //console.log('popList', isLoaded)
                });
                setIsLoaded(true);
                //console.log('outPopList', isLoaded)
            }
        }
        else {
            if (graphData != null && graphData.id != null && graphData.id.length > 0) {
                if (company.purchasedLicenses.length === 0) {
                    (0, customer_1.fetchCustomerByUserId)(graphData.id).then(function (data) {
                        setCompany(data);
                    }).catch(console.error);
                }
                if (!isLoaded) {
                    (0, ticket_1.fetchTicketsByUserId)(graphData.id, currentPage, selectStatus).then(function (info) {
                        var list = info.list, count = info.count, page = info.page;
                        console.log(list);
                        console.log(count);
                        setPageData({
                            isloading: false,
                            rowData: list,
                            totalTickets: count,
                        });
                        setIsLoaded(true);
                    }).catch(console.error);
                }
            }
        }
    };
    /*Refresh page after delete ticket (click Delete Button at Action Column)*/
    var updateTicketCallback = function () {
        setIsLoaded(false);
    };
    var onLoad = function () {
        requestProfileData();
        checkIfSuperAdmin();
        populateList();
    };
    (0, react_1.useEffect)(function () {
        setPageData(function (prevState) { return (__assign(__assign({}, prevState), { rowData: [], isLoading: true })); });
        (0, ticket_1.fetchTickets)(currentPage, searchTerm, selectStatus).then(function (info) {
            var list = info.list, count = info.count, page = info.page;
            setPageData({
                isloading: false,
                rowData: list,
                totalTickets: count,
            });
            setIsLoaded(true);
        });
    }, [currentPage, setCurrentPage, isLoaded, setIsLoaded]);
    (0, react_1.useEffect)(function () {
        console.log('useEffect', !isLoaded == true);
        if (!isLoaded && inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [instance, inProgress, list, setList, isLoaded, setIsLoaded, graphData, setGraphData, isAuthorizedSuperAdmin, setIsAuthorizedSuperAdmin]);
    //(accounts[0] as AccountInfo) != null && (accounts[0] as AccountInfo).name != null 
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "card-header" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "List of Tickets")),
                React.createElement("div", { className: "filter-options" },
                    React.createElement("div", { className: "totalTicketsInternal" },
                        React.createElement("p", null,
                            "Total Tickets: ",
                            pageData.totalTickets || "...")),
                    React.createElement("div", null,
                        React.createElement("input", { placeholder: "Search Company Name", onChange: function (e) {
                                setSearchTerm(e.target.value);
                            } }),
                        React.createElement("select", { className: "filterStatus", onChange: handleSelect }, ticketStatusOptions.map(function (option) { return (React.createElement("option", { key: option.key, value: option.key }, option.value)); })),
                        React.createElement("button", { style: { padding: 0, borderRadius: "10px", marginLeft: "3px", borderColor: "white" }, color: "link", onClick: filterClick },
                            React.createElement("a", { className: "padding-default" },
                                React.createElement("img", { src: "./search.svg", className: "font-icon" }))))),
                !isAuthorizedSuperAdmin && company && company.purchasedLicenses ? React.createElement(AddNewTicketButton_1.default, { userId: graphData.id, purchasedLicenses: company.purchasedLicenses, callback: pushToList.bind(_this) }) : React.createElement(React.Fragment, null)),
            React.createElement("div", { className: "tableContainer ticketListContainer" },
                //isLoaded ? <PaginationTable columns={columns} data={list
                //    .filter((item) => item.status.includes(selectStatus))
                //    .filter((item) => item.companyName.toLowerCase().includes(searchTerm.toLowerCase()))
                //} /> : <>Loading...</>
                React.createElement(table_1.default, { columns: columns, data: pageData.rowData, isloading: pageData.isloading }),
                React.createElement(pagination_1.default, { totalrows: pageData.totalTickets, pagechangehandler: setCurrentPage, rowsperpage: 25 })))));
};
exports.default = TicketListPage;
//# sourceMappingURL=TicketListPage.js.map